export default{
  label: "wrapping",
  valueScope:[
    'text-wrap',
    'text-nowrap',
  ]
}



// WEBPACK FOOTER //
// ./src/shell/schemas/general/text/wrapping.js